import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { messages } from '@/i18n';

/**
 * Every feature route renders one of these for now. The screens themselves are
 * out of scope for this slice; what is in scope is that the guard chain, the
 * role-to-route map and the shell are proven before six teams build on them.
 */
export function PlaceholderScreen({ title, note }: { title: string; note?: string }) {
  return (
    <section className="mx-auto max-w-3xl">
      <div className="mb-6 flex items-center gap-3">
        <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
        <Badge variant="outline">Not built</Badge>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>{messages.common.comingSoon}</CardTitle>
          <CardDescription>{messages.common.placeholderBody}</CardDescription>
        </CardHeader>
        {note ? (
          <CardContent>
            <p className="text-muted-foreground text-sm">{note}</p>
          </CardContent>
        ) : null}
      </Card>
    </section>
  );
}
